import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
import { formatNumber } from "../../libraries/helper";
 
export default () => {

  const moduleName = "reward_rules";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.reward_rules_destroy, location.search]);

  useEffect(() => {
    if (appReducer.reward_rules_list != undefined) {
      setRows(appReducer.reward_rules_list.data)
      setTotalPages(appReducer.reward_rules_list.count)
    }
  }, [appReducer])

  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'کمترین خرید',
      selector: row => `${formatNumber(row.min)} تومان`,
    },
    {
      name: 'بیشترین خرید',
      selector: row => `${formatNumber(row.max)} تومان`,
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages} columns={columns} data={rows} />;

};
